import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import {verifyUser} from "../services/invoice";
import Loading from "./Loading/Loading";
import {setToken, setAuthenticatedStatus} from "../store/slices/app";
import {useSelector, useDispatch} from "react-redux";

export default function ProtectedRoute({component: Component}) {
    let [isLoading, setLoading] = useState(false)
    let [isAuthenticated, setIsAuthenticated] = useState(false)
    let navigate = useNavigate()
    let [searchParams] = useSearchParams();
    const store_token = useSelector(state => state.app.token)
    const store_isAuthenticated = useSelector(state => state.app.isAuthenticated)
    const token = store_token ? store_token : searchParams.get("token")
    const dispatch = useDispatch()

    useEffect(() => {
        if (!token) {
            navigate('/error')
            return
        }
        if (store_isAuthenticated && token) {
            return
        }


        async function authenticate() {
            try {
                setLoading(true)
                let data = await verifyUser(token)
                if (data.status === 200) {
                    dispatch(setAuthenticatedStatus({value: true}))
                    dispatch(setToken({value: token}))
                    setIsAuthenticated(true)
                    setLoading(false)
                } else {
                    setLoading(false)
                    navigate('/error')
                }
            } catch(e) {
                setLoading(false)
                navigate('/error')
            }
        }

        authenticate()

        return () => {
            // clear()
        }
    }, [])
    return (isLoading ? <Loading isShowing={isLoading}/> : (isAuthenticated ? <Component/> :
        <Loading isShowing={true}/>));
}
